import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorLoading from '../components/error-loading/ErrorLoading';
import Parser from 'html-react-parser';
import DomainList from '../components/domain-list/DomainList';
import FrameworkVersions from '../containers/framework-versions/FrameworkVersions';

import CompetencyService from '../services/competency/competency';
import ActiveRequestsService from '../services/active-requests/active-requests';
import { safeFlat, removeHtmlTags } from '../services/util/util';
import { Link } from 'react-router-dom';

import masterListSource from './MasterList';
import Copyright from './Copyright';
import auth from '../services/util/auth';

import FundedByEU from '../components/assets/co-funded-by-EU.png';

class DraftPreview extends Component {
  static propTypes = {
    match: PropTypes.shape({
      match: PropTypes.shape({ framework: PropTypes.string })
    })
  };

  competencyService = new CompetencyService();
  activeRequests = new ActiveRequestsService();

  state = {
    framework: '',
    frameworkVersion: '',
    frameworkName: '',
    frameworkStatus: '',
    frameworkDescription: '',
    versions: [],
    domains: [],
    filter: '',
    filteredDomains: [],
    loadingError: false,
    attributeTypes: [],
    pathnames: this.props.history.location.pathname,
    pathnames_count: 0,
    coreFrameworkName: '',
    parentFramework: null
  };

  static getDerivedStateFromProps(props, state) {
    const { framework, version: frameworkVersion } = props.match.params;
    if (
      framework !== state.framework ||
      frameworkVersion !== state.frameworkVersion
    ) {
      return {
        framework,
        frameworkVersion,
        domains: [],
        loadingError: false
      };
    }

    // No state update necessary
    return null;
  }

  async setCurrentTab() {
    let visibleTabs = [];
    if (auth.currently_logged_in_user.is_logged_in) {
      visibleTabs.push('competencies');
      visibleTabs.push('career-profiles');
      visibleTabs.push('career-pathways');
      visibleTabs.push('training-resources');
      visibleTabs.push('learning-pathways');
    } else {
      visibleTabs.push('competencies');
      if (this.state.profileCount > 0) {
        visibleTabs.push('career-profiles');
      }
      if (this.state.careerPathwayCount > 0) {
        visibleTabs.push('career-pathways');
      }
      if (this.state.trainingResourcesExist) {
        visibleTabs.push('training-resources');
      }
      if (this.state.pathwayCount > 0) {
        visibleTabs.push('learning-pathways');
      }
    }

    visibleTabs.push('export');
    await this.setState({ visibleTabs: visibleTabs });
    let currentUrl = window.location.href;
    let selectedTabIndex = 0;
    for (let i = 0; i < this.state.visibleTabs.length; i++) {
      if (currentUrl.includes(this.state.visibleTabs[i])) {
        selectedTabIndex = i;
      }
    }
    await this.setState({
      selectedTabIndex: selectedTabIndex
    });
  }

  async componentDidMount() {
    const { framework, version: frameworkVersion } = this.props.match.params;
    this.setState({ pathnames_count: this.state.pathnames.split('/').length });
    window.vfTabs();
    try {
      this.activeRequests.startRequest();
      await Promise.all([
        await this.fetchFramework(framework, frameworkVersion)
        // await this.fetchVersions(framework),
      ]);
    } catch (error) {
      this.setState({ loadingError: true });
      console.log(error);
    } finally {
      this.activeRequests.finishRequest();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const { framework, frameworkVersion, domains, loadingError } = this.state;
    if (
      framework !== prevState.framework ||
      frameworkVersion !== prevState.frameworkVersion
    ) {
      if (domains.length === 0 && !loadingError) {
        try {
          this.activeRequests.startRequest();
          await this.fetchFramework(framework, frameworkVersion);
        } catch (error) {
          this.setState({ loadingError: true });
          console.log(error);
        } finally {
          this.activeRequests.finishRequest();
        }
      }
    }
  }

  async fetchFramework(framework, frameworkVersion) {
    window.scroll(0, 0);
    const frameworkData = await this.competencyService.getVersionedDraftFramework(
      framework
    );
    let domains = safeFlat(frameworkData.map(item => item.domains));
    const coreDomains = safeFlat(frameworkData.map(item => item.core_domains));
    const frameworkDescription = removeHtmlTags(frameworkData[0].description);

    if (coreDomains && coreDomains[0] !== undefined) {
      domains = coreDomains.concat(domains);
    }

    this.setState({
      frameworkName: frameworkData[0].title,
      frameworkDescription,
      domains,
      filteredDomains: domains,
      frameWorkId: frameworkData[0].nid,
      coreFrameworkName:
        frameworkData[0]?.extension?.extension ||
        (Array.isArray(frameworkData[0]?.extension) &&
          frameworkData[0]?.extension[0]?.extension)
          ? frameworkData[0]?.extension[0]?.core_framework_name
          : ''
    });

    const allFrameworks = await this.competencyService.getAllVersionedFrameworks();
    const currentFramework = allFrameworks.filter(
      // fw => fw.title.toLowerCase().replace(/ /g, '') === framework
      fw => fw.machine_name === framework
    );
    if (currentFramework.length > 0) {
      // const versionStatus = currentFramework[0].versions.filter(
      //   vr => vr.number === frameworkVersion
      // );
      // this.setState({ frameworkStatus: versionStatus[0].status });
      let attrTypes = currentFramework[0].attribute_types.map(
        type => type.title
      );
      this.setState({ attributeTypes: attrTypes });
      const parent = allFrameworks.filter(
        fw =>
          fw?.extension[0]?.core_framework_name ===
          currentFramework[0].title.toLowerCase().replace(/ /g, '')
      );
      this.setState({ parentFramework: parent.length > 0 ? parent : null });
    }
  }

  async fetchVersions(framework) {
    const allFrameworks = await this.competencyService.getAllVersionedFrameworks();
    const currentFramework = allFrameworks.filter(
      // fw => fw.title.toLowerCase().replace(/ /g, '') === framework
      fw => fw.machine_name === framework
    );
    if (currentFramework.length > 0) {
      this.setState({ versions: currentFramework[0].versions.reverse() });
    }
  }

  onFilter = filter => {
    const { domains } = this.state;
    let term;
    try {
      term = new RegExp(filter, 'i');
    } catch (e) {
      term = /./;
    }
    const filteredDomains = domains.map(domain => {
      const filteredCompetencies = domain.competencies.filter(competency =>
        term.test(competency.title)
      );
      if (filteredCompetencies.length === 0) {
        return null;
      }
      return { ...domain, competencies: filteredCompetencies };
    });
    this.setState({ filter, filteredDomains });
  };

  longDesc() {
    let long_desc = masterListSource.filter(
      item => item.title === this.state.framework
    )[0].long_desc;
    let developed_by = masterListSource.filter(
      item => item.title === this.state.framework
    )[0].title_with_case;
    let link_to_framework = masterListSource.filter(
      item => item.title === this.state.framework
    )[0].link;
    let acknowledgement_text = masterListSource.filter(
      item => item.title === this.state.framework
    )[0].acknowledgement_text;
    let acknowledgement_logo_src = masterListSource.filter(
      item => item.title === this.state.framework
    )[0].acknowledgement_logo_src;
    return (
      "<div className='vf-grid vf-grid__col-4'><div className='vf-grid__col--span-3'><h3>Developed by: <a className='vf-link' href='" +
      link_to_framework +
      "'>" +
      developed_by +
      '</a></h3>' +
      long_desc +
      acknowledgement_text +
      (acknowledgement_logo_src
        ? '<img style="width:35%" src=' + FundedByEU + ' />'
        : '') +
      '<div className="vf-u-margin--100"><a className="vf-link" href="/framework/' +
      this.state.framework +
      '/' +
      this.state.frameworkVersion +
      '/export-framework">Export framework</a><div></div><div></div></div>'
    );
  }

  render() {
    const {
      framework,
      frameworkVersion,
      frameworkStatus,
      filteredDomains,
      versions,
      filter,
      loadingError,
      attributeTypes
    } = this.state;

    if (loadingError) {
      return <ErrorLoading />;
    }

    const domainList = filteredDomains.map(domain =>
      domain === null ? null : (
        <DomainList
          key={domain.nid}
          framework={framework}
          domain={domain}
          disable={true}
          version={frameworkVersion}
          attributeTypes={attributeTypes}
          trainingResourcesExist={this.state.trainingResourcesExist}
        />
      )
    );

    const shortDescFramework = () => {
      let item = masterListSource.filter(
        item => item.title === this.state.framework
      )[0].short_desc;
      return item.charAt(0).toUpperCase() + item.slice(1);
    };

    return (
      <>
        <div className="vf-u-margin__top--400" />
        <h1>
          {' '}
          {
            masterListSource.filter(
              item => item.title === this.state.framework
            )[0].new_desc
          }{' '}
        </h1>

        <div className="vf-u-margin__top--400" />
        <h2>
          {
            masterListSource.filter(
              item => item.title === this.state.framework
            )[0].intro_text
          }{' '}
        </h2>
        <p>
          This competency framework is developed by{' '}
          {
            masterListSource.filter(
              item => item.title === this.state.framework
            )[0].title_with_case
          }
          <span className="vf-badge" style={{ marginLeft: '10px' }}>
            {frameworkVersion}
          </span>
          <span className="vf-badge vf-badge--primary"> {frameworkStatus}</span>
        </p>

        <div className="vf-u-margin__top--1200" />

        <h3>{shortDescFramework()} competencies</h3>
        <form action="#" className="vf-form | vf-search vf-search--inline">
          <div className="vf-form__item | vf-search__item">
            <label
              className="vf-form__label vf-u-sr-only | vf-search__label"
              htmlFor="inlinesearchitem"
            >
              Inline search
            </label>
            <input
              type="search"
              placeholder="Filter competencies"
              id="inlinesearchitem"
              className="vf-form__input | vf-search__input"
              onChange={event => this.onFilter(event.target.value)}
              value={filter}
            />
          </div>
        </form>
        <div className="vf-u-margin__top--800" />

        <div>{domainList}</div>
        <div className="vf-u-margin__top--800" />
        <hr />
        {Parser(this.longDesc())}
        <div className="vf-u-margin__top--400" />
        <div className="vf-grid">
          <div>
            {this.state.parentFramework ? (
              <div>
                <h3 className="vf-u-type__text-heading--4">Extensions</h3>

                {this.state.parentFramework.map((fw, index) => (
                  <div key={index}>
                    <Link
                      to={`/framework/${fw.machine_name}/${
                        fw.versions[0].number
                      }/competencies`}
                    >
                      {fw.title}
                    </Link>
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}

            <FrameworkVersions framework={framework} versions={versions} />
          </div>
          <div>
            <Copyright framework={framework} />
          </div>
        </div>
        <div className="vf-u-margin__top--1600" />
      </>
    );
  }
}

export default DraftPreview;
